module.exports = __webpack_public_path__ + "img/video-placeholder.b9ca4684.png";